<div class="source-form-scheduling-wrap">
  <div class="schedule-data">
    <div class="top-bar">
      <ng-content></ng-content>

      <div class="scheduling-processing-toggle" *ngIf="isShowScheduling">
        <mat-slide-toggle class="toggle" color="primary" [formControl]="scheduleControl">
          Schedule Processing
        </mat-slide-toggle>
      </div>
    </div>

    <div class="time-filters" *ngIf="isShowFilters && isShowScheduling">
      <mat-form-field *ngFor="let select of selectSchema" [formGroup]="selectsFormGroup"
                      [ngStyle]="{ 'display' : select.isDisplay ? 'block' : 'none'  }">
        <mat-select
          [placeholder]="select.placeholder | translate"
          [formControl]="select.formControl"
          (valueChange)="onChangeValue()"
        >
          <mat-option *ngFor="let option of select.options" [value]="option.value">
            {{ option.userDisplay | translate }}
          </mat-option>
        </mat-select>

        <span class="company-time-label"
              *ngIf="select.timeLabel">{{ companyTimeLabel | translate }} {{ companyLocalTime }}</span>
      </mat-form-field>
    </div>
  </div>
</div>
